import * as AuthActions from './actions';
import { AuthState, initialState } from './state';

export function authReducer(
  state: AuthState = initialState,
  action: AuthActions.LoginUser | AuthActions.LogoutUser | AuthActions.LoadUser,
): AuthState {
  switch (action.type) {
    case AuthActions.LOGIN_USER:
      const loginAction = action as AuthActions.LoginUser;
      localStorage.setItem('cassa.jwttoken', loginAction.payload);
      return {
        ...state,
        isLoggedIn: true,
        token: loginAction.payload,
      };
    case AuthActions.LOGOUT_USER:
      localStorage.removeItem('cassa.jwttoken');
      localStorage.removeItem('cassa.userRoles');
      localStorage.removeItem('cassa.userName');
      return {
        ...state,
        isLoggedIn: false,
        token: null,
        currentUser: {
          email: 'mail@example.com',
          picture: null,
        },
      };
    case AuthActions.LOAD_USER:
      const token = localStorage.getItem('cassa.jwttoken');
      return {
        ...state,
        isLoggedIn: !!token,
        token: token,
      };
    default:
      return state;
  }
}
